"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Slot_exports = {};
__export(Slot_exports, {
  Slot: () => Slot
});
module.exports = __toCommonJS(Slot_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react_slot = require("@radix-ui/react-slot");
var import_react = require("react");
var import_react_native = require("react-native");
function ShimSlotForReactNative(Component) {
  return /* @__PURE__ */ (0, import_react.forwardRef)(function RNSlotHOC(param, ref) {
    var { style, ...props } = param;
    if (process.env.NODE_ENV !== "production") {
      if (Array.isArray(style)) {
        throw new Error("Slot does not support array styles. Use StyleSheet.flatten() or an object style instead.");
      }
    }
    style = (0, import_react.useMemo)(function() {
      return import_react_native.StyleSheet.flatten(style);
    }, [
      style
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {
      ref,
      ...props,
      style
    });
  });
}
var Slot = ShimSlotForReactNative(import_react_slot.Slot);
//# sourceMappingURL=Slot.js.map
